module.exports = {
      id: "gift-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#gift-icon",
      toString: function () {
        return this.url;
      }
    }